import React, { PureComponent } from 'react';
import '../App.css';
import firebase, { auth, provider } from '../firebase.js';
import {Alert, ToggleButtonGroup, ToggleButton, Button, Well, Glyphicon, ProgressBar, Tabs, Tab, Panel, PanelGroup} from 'react-bootstrap';
import { StickyContainer, Sticky} from 'react-sticky';
import jsPDF from 'jspdf';
import {Link, useParams, useLocation, withRouter} from "react-router-dom";
import mainLogo from'../orthopowertools.png';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import Slider, {createSliderWithTooltip} from 'rc-slider';

///////////////////////////////////////////Calculator Methods
    
    
class Buttons1 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent1(value);        
    if (value === 4){
        this.props.callbackFromParent1_text('None at all');
        this.props.callbackFromParent1_complete(1);}
    if (value === 3){
        this.props.callbackFromParent1_text('Slight');
        this.props.callbackFromParent1_complete(1);}
    if (value === 2){
        this.props.callbackFromParent1_text('Moderate');
        this.props.callbackFromParent1_complete(1);}
    if (value === 1){
        this.props.callbackFromParent1_text('Extreme');
        this.props.callbackFromParent1_complete(1);}
    if (value === 0){
        this.props.callbackFromParent1_text('Unable to do');
        this.props.callbackFromParent1_complete(1);}
    if (value === .001){
        this.props.callbackFromParent1_text('N/A');
        this.props.callbackFromParent1_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>1. Standing.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0.001}> {(this.state.clicked === 0.001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>1. Standing.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0.001}> {(this.state.clicked === 0.001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons2 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent2(value);        
    if (value === 4){
        this.props.callbackFromParent2_text('None at all');
        this.props.callbackFromParent2_complete(1);}
    if (value === 3){
        this.props.callbackFromParent2_text('Slight');
        this.props.callbackFromParent2_complete(1);}
    if (value === 2){
        this.props.callbackFromParent2_text('Moderate');
        this.props.callbackFromParent2_complete(1);}
    if (value === 1){
        this.props.callbackFromParent2_text('Extreme');
        this.props.callbackFromParent2_complete(1);}
    if (value === 0){
        this.props.callbackFromParent2_text('Unable to do');
        this.props.callbackFromParent2_complete(1);}
    if (value === .001){
        this.props.callbackFromParent2_text('N/A');
        this.props.callbackFromParent2_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>2. Walking on even ground.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>2. Walking on even ground.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons3 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent3(value);        
    if (value === 4){
        this.props.callbackFromParent3_text('None at all');
        this.props.callbackFromParent3_complete(1);}
    if (value === 3){
        this.props.callbackFromParent3_text('Slight');
        this.props.callbackFromParent3_complete(1);}
    if (value === 2){
        this.props.callbackFromParent3_text('Moderate');
        this.props.callbackFromParent3_complete(1);}
    if (value === 1){
        this.props.callbackFromParent3_text('Extreme');
        this.props.callbackFromParent3_complete(1);}
    if (value === 0){
        this.props.callbackFromParent3_text('Unable to do');
        this.props.callbackFromParent3_complete(1);}
    if (value === .001){
        this.props.callbackFromParent3_text('N/A');
        this.props.callbackFromParent3_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>3. Walking on even ground without shoes.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>3. Walking on even ground without shoes.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}

class Buttons4 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent4(value);        
    if (value === 4){
        this.props.callbackFromParent4_text('None at all');
        this.props.callbackFromParent4_complete(1);}
    if (value === 3){
        this.props.callbackFromParent4_text('Slight');
        this.props.callbackFromParent4_complete(1);}
    if (value === 2){
        this.props.callbackFromParent4_text('Moderate');
        this.props.callbackFromParent4_complete(1);}
    if (value === 1){
        this.props.callbackFromParent4_text('Extreme');
        this.props.callbackFromParent4_complete(1);}
    if (value === 0){
        this.props.callbackFromParent4_text('Unable to do');
        this.props.callbackFromParent4_complete(1);}
    if (value === .001){
        this.props.callbackFromParent4_text('N/A');
        this.props.callbackFromParent4_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>4. Walking up hills</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>4. Walking up hills</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons5 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent5(value);        
    if (value === 4){
        this.props.callbackFromParent5_text('None at all');
        this.props.callbackFromParent5_complete(1);}
    if (value === 3){
        this.props.callbackFromParent5_text('Slight');
        this.props.callbackFromParent5_complete(1);}
    if (value === 2){
        this.props.callbackFromParent5_text('Moderate');
        this.props.callbackFromParent5_complete(1);}
    if (value === 1){
        this.props.callbackFromParent5_text('Extreme');
        this.props.callbackFromParent5_complete(1);}
    if (value === 0){
        this.props.callbackFromParent5_text('Unable to do');
        this.props.callbackFromParent5_complete(1);}
    if (value === .001){
        this.props.callbackFromParent5_text('N/A');
        this.props.callbackFromParent5_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>5. Walking down hills.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>5. Walking down hills.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons6 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent6(value);        
    if (value === 4){
        this.props.callbackFromParent6_text('None at all');
        this.props.callbackFromParent6_complete(1);}
    if (value === 3){
        this.props.callbackFromParent6_text('Slight');
        this.props.callbackFromParent6_complete(1);}
    if (value === 2){
        this.props.callbackFromParent6_text('Moderate');
        this.props.callbackFromParent6_complete(1);}
    if (value === 1){
        this.props.callbackFromParent6_text('Extreme');
        this.props.callbackFromParent6_complete(1);}
    if (value === 0){
        this.props.callbackFromParent6_text('Unable to do');
        this.props.callbackFromParent6_complete(1);}
    if (value === .001){
        this.props.callbackFromParent6_text('N/A');
        this.props.callbackFromParent6_complete(0);}        
    this.setState({clicked: value});
    }        
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>6. Going up stairs</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>6. Going up stairs</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons7 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent7(value);        
    if (value === 4){
        this.props.callbackFromParent7_text('None at all');
        this.props.callbackFromParent7_complete(1);}
    if (value === 3){
        this.props.callbackFromParent7_text('Slight');
        this.props.callbackFromParent7_complete(1);}
    if (value === 2){
        this.props.callbackFromParent7_text('Moderate');
        this.props.callbackFromParent7_complete(1);}
    if (value === 1){
        this.props.callbackFromParent7_text('Extreme');
        this.props.callbackFromParent7_complete(1);}
    if (value === 0){
        this.props.callbackFromParent7_text('Unable to do');
        this.props.callbackFromParent7_complete(1);}
    if (value === .001){
        this.props.callbackFromParent7_text('N/A');
        this.props.callbackFromParent7_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>7. Going down stairs</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>7. Going down stairs</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons8 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent8(value);        
    if (value === 4){
        this.props.callbackFromParent8_text('None at all');
        this.props.callbackFromParent8_complete(1);}
    if (value === 3){
        this.props.callbackFromParent8_text('Slight');
        this.props.callbackFromParent8_complete(1);}
    if (value === 2){
        this.props.callbackFromParent8_text('Moderate');
        this.props.callbackFromParent8_complete(1);}
    if (value === 1){
        this.props.callbackFromParent8_text('Extreme');
        this.props.callbackFromParent8_complete(1);}
    if (value === 0){
        this.props.callbackFromParent8_text('Unable to do');
        this.props.callbackFromParent8_complete(1);}
    if (value === .001){
        this.props.callbackFromParent8_text('N/A');
        this.props.callbackFromParent8_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>8. Walking on uneven ground.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>8. Walking on uneven ground.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons9 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent9(value);        
    if (value === 4){
        this.props.callbackFromParent9_text('None at all');
        this.props.callbackFromParent9_complete(1);}
    if (value === 3){
        this.props.callbackFromParent9_text('Slight');
        this.props.callbackFromParent9_complete(1);}
    if (value === 2){
        this.props.callbackFromParent9_text('Moderate');
        this.props.callbackFromParent9_complete(1);}
    if (value === 1){
        this.props.callbackFromParent9_text('Extreme');
        this.props.callbackFromParent9_complete(1);}
    if (value === 0){
        this.props.callbackFromParent9_text('Unable to do');
        this.props.callbackFromParent9_complete(1);}
    if (value === .001){
        this.props.callbackFromParent9_text('N/A');
        this.props.callbackFromParent9_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>9. Stepping up and down curbs.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>9. Stepping up and down curbs.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}



class Buttons10 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent10(value);        
    if (value === 4){
        this.props.callbackFromParent10_text('None at all');
        this.props.callbackFromParent10_complete(1);}
    if (value === 3){
        this.props.callbackFromParent10_text('Slight');
        this.props.callbackFromParent10_complete(1);}
    if (value === 2){
        this.props.callbackFromParent10_text('Moderate');
        this.props.callbackFromParent10_complete(1);}
    if (value === 1){
        this.props.callbackFromParent10_text('Extreme');
        this.props.callbackFromParent10_complete(1);}
    if (value === 0){
        this.props.callbackFromParent10_text('Unable to do');
        this.props.callbackFromParent10_complete(1);}
    if (value === .001){
        this.props.callbackFromParent10_text('N/A');
        this.props.callbackFromParent10_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>10. Squatting.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>10. Squatting.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons11 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent11(value);        
    if (value === 4){
        this.props.callbackFromParent11_text('None at all');
        this.props.callbackFromParent11_complete(1);}
    if (value === 3){
        this.props.callbackFromParent11_text('Slight');
        this.props.callbackFromParent11_complete(1);}
    if (value === 2){
        this.props.callbackFromParent11_text('Moderate');
        this.props.callbackFromParent11_complete(1);}
    if (value === 1){
        this.props.callbackFromParent11_text('Extreme');
        this.props.callbackFromParent11_complete(1);}
    if (value === 0){
        this.props.callbackFromParent11_text('Unable to do');
        this.props.callbackFromParent11_complete(1);}
    if (value === .001){
        this.props.callbackFromParent11_text('N/A');
        this.props.callbackFromParent11_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>11. Coming up on your toes.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>11. Coming up on your toes.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons12 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent12(value);        
    if (value === 4){
        this.props.callbackFromParent12_text('None at all');
        this.props.callbackFromParent12_complete(1);}
    if (value === 3){
        this.props.callbackFromParent12_text('Slight');
        this.props.callbackFromParent12_complete(1);}
    if (value === 2){
        this.props.callbackFromParent12_text('Moderate');
        this.props.callbackFromParent12_complete(1);}
    if (value === 1){
        this.props.callbackFromParent12_text('Extreme');
        this.props.callbackFromParent12_complete(1);}
    if (value === 0){
        this.props.callbackFromParent12_text('Unable to do');
        this.props.callbackFromParent12_complete(1);}
    if (value === .001){
        this.props.callbackFromParent12_text('N/A');
        this.props.callbackFromParent12_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>12. Walking initially.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>12. Walking initially.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons13 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent13(value);        
    if (value === 4){
        this.props.callbackFromParent13_text('None at all');
        this.props.callbackFromParent13_complete(1);}
    if (value === 3){
        this.props.callbackFromParent13_text('Slight');
        this.props.callbackFromParent13_complete(1);}
    if (value === 2){
        this.props.callbackFromParent13_text('Moderate');
        this.props.callbackFromParent13_complete(1);}
    if (value === 1){
        this.props.callbackFromParent13_text('Extreme');
        this.props.callbackFromParent13_complete(1);}
    if (value === 0){
        this.props.callbackFromParent13_text('Unable to do');
        this.props.callbackFromParent13_complete(1);}
    if (value === .001){
        this.props.callbackFromParent13_text('N/A');
        this.props.callbackFromParent13_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>13. Walking 5 minutes or less.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>13. Walking 5 minutes or less.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons14 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent14(value);        
    if (value === 4){
        this.props.callbackFromParent14_text('None at all');
        this.props.callbackFromParent14_complete(1);}
    if (value === 3){
        this.props.callbackFromParent14_text('Slight');
        this.props.callbackFromParent14_complete(1);}
    if (value === 2){
        this.props.callbackFromParent14_text('Moderate');
        this.props.callbackFromParent14_complete(1);}
    if (value === 1){
        this.props.callbackFromParent14_text('Extreme');
        this.props.callbackFromParent14_complete(1);}
    if (value === 0){
        this.props.callbackFromParent14_text('Unable to do');
        this.props.callbackFromParent14_complete(1);}
    if (value === .001){
        this.props.callbackFromParent14_text('N/A');
        this.props.callbackFromParent14_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>14. Walking approximately 10 minutes.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>14. Walking approximately 10 minutes.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons15 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent15(value);        
    if (value === 4){
        this.props.callbackFromParent15_text('None at all');
        this.props.callbackFromParent15_complete(1);}
    if (value === 3){
        this.props.callbackFromParent15_text('Slight');
        this.props.callbackFromParent15_complete(1);}
    if (value === 2){
        this.props.callbackFromParent15_text('Moderate');
        this.props.callbackFromParent15_complete(1);}
    if (value === 1){
        this.props.callbackFromParent15_text('Extreme');
        this.props.callbackFromParent15_complete(1);}
    if (value === 0){
        this.props.callbackFromParent15_text('Unable to do');
        this.props.callbackFromParent15_complete(1);}
    if (value === .001){
        this.props.callbackFromParent15_text('N/A');
        this.props.callbackFromParent15_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>15. Walking 15 minutes or greater.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>15. Walking 15 minutes or greater.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons16 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent16(value);        
    if (value === 4){
        this.props.callbackFromParent16_text('None at all');
        this.props.callbackFromParent16_complete(1);}
    if (value === 3){
        this.props.callbackFromParent16_text('Slight');
        this.props.callbackFromParent16_complete(1);}
    if (value === 2){
        this.props.callbackFromParent16_text('Moderate');
        this.props.callbackFromParent16_complete(1);}
    if (value === 1){
        this.props.callbackFromParent16_text('Extreme');
        this.props.callbackFromParent16_complete(1);}
    if (value === 0){
        this.props.callbackFromParent16_text('Unable to do');
        this.props.callbackFromParent16_complete(1);}
    if (value === .001){
        this.props.callbackFromParent16_text('N/A');
        this.props.callbackFromParent16_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>16. Home responsibilities.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>16. Home responsibilities.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons17 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent17(value);        
    if (value === 4){
        this.props.callbackFromParent17_text('None at all');
        this.props.callbackFromParent17_complete(1);}
    if (value === 3){
        this.props.callbackFromParent17_text('Slight');
        this.props.callbackFromParent17_complete(1);}
    if (value === 2){
        this.props.callbackFromParent17_text('Moderate');
        this.props.callbackFromParent17_complete(1);}
    if (value === 1){
        this.props.callbackFromParent17_text('Extreme');
        this.props.callbackFromParent17_complete(1);}
    if (value === 0){
        this.props.callbackFromParent17_text('Unable to do');
        this.props.callbackFromParent17_complete(1);}
    if (value === .001){
        this.props.callbackFromParent17_text('N/A');
        this.props.callbackFromParent17_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>17. Activities of daily living.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>17. Activities of daily living.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons18 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent18(value);        
    if (value === 4){
        this.props.callbackFromParent18_text('None at all');
        this.props.callbackFromParent18_complete(1);}
    if (value === 3){
        this.props.callbackFromParent18_text('Slight');
        this.props.callbackFromParent18_complete(1);}
    if (value === 2){
        this.props.callbackFromParent18_text('Moderate');
        this.props.callbackFromParent18_complete(1);}
    if (value === 1){
        this.props.callbackFromParent18_text('Extreme');
        this.props.callbackFromParent18_complete(1);}
    if (value === 0){
        this.props.callbackFromParent18_text('Unable to do');
        this.props.callbackFromParent18_complete(1);}
    if (value === .001){
        this.props.callbackFromParent18_text('N/A');
        this.props.callbackFromParent18_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>18. Personal care.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>18. Personal care.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons19 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent19(value);        
    if (value === 4){
        this.props.callbackFromParent19_text('None at all');
        this.props.callbackFromParent19_complete(1);}
    if (value === 3){
        this.props.callbackFromParent19_text('Slight');
        this.props.callbackFromParent19_complete(1);}
    if (value === 2){
        this.props.callbackFromParent19_text('Moderate');
        this.props.callbackFromParent19_complete(1);}
    if (value === 1){
        this.props.callbackFromParent19_text('Extreme');
        this.props.callbackFromParent19_complete(1);}
    if (value === 0){
        this.props.callbackFromParent19_text('Unable to do');
        this.props.callbackFromParent19_complete(1);}
    if (value === .001){
        this.props.callbackFromParent19_text('N/A');
        this.props.callbackFromParent19_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>19. Light to moderate work (standing, walking).</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>19. Light to moderate work (standing, walking).</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons20 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent20(value);        
    if (value === 4){
        this.props.callbackFromParent20_text('None at all');
        this.props.callbackFromParent20_complete(1);}
    if (value === 3){
        this.props.callbackFromParent20_text('Slight');
        this.props.callbackFromParent20_complete(1);}
    if (value === 2){
        this.props.callbackFromParent20_text('Moderate');
        this.props.callbackFromParent20_complete(1);}
    if (value === 1){
        this.props.callbackFromParent20_text('Extreme');
        this.props.callbackFromParent20_complete(1);}
    if (value === 0){
        this.props.callbackFromParent20_text('Unable to do');
        this.props.callbackFromParent20_complete(1);}
    if (value === .001){
        this.props.callbackFromParent20_text('N/A');
        this.props.callbackFromParent20_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>20. Heavy work (push/pulling, climbing, carrying).</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>20. Heavy work (push/pulling, climbing, carrying).</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons21 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent21(value);        
    if (value === 4){
        this.props.callbackFromParent21_text('None at all');
        this.props.callbackFromParent21_complete(1);}
    if (value === 3){
        this.props.callbackFromParent21_text('Slight');
        this.props.callbackFromParent21_complete(1);}
    if (value === 2){
        this.props.callbackFromParent21_text('Moderate');
        this.props.callbackFromParent21_complete(1);}
    if (value === 1){
        this.props.callbackFromParent21_text('Extreme');
        this.props.callbackFromParent21_complete(1);}
    if (value === 0){
        this.props.callbackFromParent21_text('Unable to do');
        this.props.callbackFromParent21_complete(1);}
    if (value === .001){
        this.props.callbackFromParent21_text('N/A');
        this.props.callbackFromParent21_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>21. Recreational activities.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>21. Recreational activities.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


    const wrapperStyle2 = {'max-width': '400px', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': 0, 'margin-bottom': 130 };
    const marks5 = {
      0: <strong>0<p>Inability to perform daily activities</p></strong>,
      10: 10,
      20: 20,
      30: 30,
      40: 40,
      50: <strong>50</strong>,
      60: 60,
      70: 70,
      80: 80,
      90: 90,
      100: <strong>100<p>No change in function</p></strong>,
    };

class Slider22 extends PureComponent {

    constructor(){
         super();
         this.state= {position: 100}
    }

    someFn (value) {
    this.props.callbackFromParent22(value);
    this.props.callbackFromParent22_text(String(value) + '%');    
    this.setState({position: value});
    }

  render() {
    return (
    <div>
    <h4>22. How would you rate your current level of function during your usual activities of daily living from 0 to 100 with 100 being your level of function prior to your foot and ankle problem and 0 being the inability to perform any of your usual daily activities.</h4>
        <div style={wrapperStyle2}>
           <Slider dots = {false} min = {0} max = {100} marks={marks5} defaultValue = {100} onChange = {(value) => this.someFn(value)} trackStyle={{ backgroundColor: '#5f8dd3'}}
        handleStyle={{
          borderColor: '#5f8dd3'
        }} dotStyle = {{borderColor: '#5f8dd3'}} />
        </div>
    </div>
  );
  }
}



class Buttons01 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent01(value);        
    if (value === 4){
        this.props.callbackFromParent01_text('None at all');
        this.props.callbackFromParent01_complete(1);}
    if (value === 3){
        this.props.callbackFromParent01_text('Slight');
        this.props.callbackFromParent01_complete(1);}
    if (value === 2){
        this.props.callbackFromParent01_text('Moderate');
        this.props.callbackFromParent01_complete(1);}
    if (value === 1){
        this.props.callbackFromParent01_text('Extreme');
        this.props.callbackFromParent01_complete(1);}
    if (value === 0){
        this.props.callbackFromParent01_text('Unable to do');
        this.props.callbackFromParent01_complete(1);}
    if (value === .001){
        this.props.callbackFromParent01_text('N/A');
        this.props.callbackFromParent01_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>1. Running.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0.001}> {(this.state.clicked === 0.001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>1. Running.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0.001}> {(this.state.clicked === 0.001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons02 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent02(value);        
    if (value === 4){
        this.props.callbackFromParent02_text('None at all');
        this.props.callbackFromParent02_complete(1);}
    if (value === 3){
        this.props.callbackFromParent02_text('Slight');
        this.props.callbackFromParent02_complete(1);}
    if (value === 2){
        this.props.callbackFromParent02_text('Moderate');
        this.props.callbackFromParent02_complete(1);}
    if (value === 1){
        this.props.callbackFromParent02_text('Extreme');
        this.props.callbackFromParent02_complete(1);}
    if (value === 0){
        this.props.callbackFromParent02_text('Unable to do');
        this.props.callbackFromParent02_complete(1);}
    if (value === .001){
        this.props.callbackFromParent02_text('N/A');
        this.props.callbackFromParent02_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>2. Jumping.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>2. Jumping.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons03 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent03(value);        
    if (value === 4){
        this.props.callbackFromParent03_text('None at all');
        this.props.callbackFromParent03_complete(1);}
    if (value === 3){
        this.props.callbackFromParent03_text('Slight');
        this.props.callbackFromParent03_complete(1);}
    if (value === 2){
        this.props.callbackFromParent03_text('Moderate');
        this.props.callbackFromParent03_complete(1);}
    if (value === 1){
        this.props.callbackFromParent03_text('Extreme');
        this.props.callbackFromParent03_complete(1);}
    if (value === 0){
        this.props.callbackFromParent03_text('Unable to do');
        this.props.callbackFromParent03_complete(1);}
    if (value === .001){
        this.props.callbackFromParent03_text('N/A');
        this.props.callbackFromParent03_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>3. Landing.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>3. Landing.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}

class Buttons04 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent04(value);        
    if (value === 4){
        this.props.callbackFromParent04_text('None at all');
        this.props.callbackFromParent04_complete(1);}
    if (value === 3){
        this.props.callbackFromParent04_text('Slight');
        this.props.callbackFromParent04_complete(1);}
    if (value === 2){
        this.props.callbackFromParent04_text('Moderate');
        this.props.callbackFromParent04_complete(1);}
    if (value === 1){
        this.props.callbackFromParent04_text('Extreme');
        this.props.callbackFromParent04_complete(1);}
    if (value === 0){
        this.props.callbackFromParent04_text('Unable to do');
        this.props.callbackFromParent04_complete(1);}
    if (value === .001){
        this.props.callbackFromParent04_text('N/A');
        this.props.callbackFromParent04_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>4. Starting and stopping quickly.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>4. Starting and stopping quickly.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons05 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent05(value);        
    if (value === 4){
        this.props.callbackFromParent05_text('None at all');
        this.props.callbackFromParent05_complete(1);}
    if (value === 3){
        this.props.callbackFromParent05_text('Slight');
        this.props.callbackFromParent05_complete(1);}
    if (value === 2){
        this.props.callbackFromParent05_text('Moderate');
        this.props.callbackFromParent05_complete(1);}
    if (value === 1){
        this.props.callbackFromParent05_text('Extreme');
        this.props.callbackFromParent05_complete(1);}
    if (value === 0){
        this.props.callbackFromParent05_text('Unable to do');
        this.props.callbackFromParent05_complete(1);}
    if (value === .001){
        this.props.callbackFromParent05_text('N/A');
        this.props.callbackFromParent05_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>5. Cutting/lateral movements.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>5. Cutting/lateral movements.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons06 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent06(value);        
    if (value === 4){
        this.props.callbackFromParent06_text('None at all');
        this.props.callbackFromParent06_complete(1);}
    if (value === 3){
        this.props.callbackFromParent06_text('Slight');
        this.props.callbackFromParent06_complete(1);}
    if (value === 2){
        this.props.callbackFromParent06_text('Moderate');
        this.props.callbackFromParent06_complete(1);}
    if (value === 1){
        this.props.callbackFromParent06_text('Extreme');
        this.props.callbackFromParent06_complete(1);}
    if (value === 0){
        this.props.callbackFromParent06_text('Unable to do');
        this.props.callbackFromParent06_complete(1);}
    if (value === .001){
        this.props.callbackFromParent06_text('N/A');
        this.props.callbackFromParent06_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>6. Low impact activities.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>6. Low impact activities.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}










class Buttons07 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent07(value);        
    if (value === 4){
        this.props.callbackFromParent07_text('None at all');
        this.props.callbackFromParent07_complete(1);}
    if (value === 3){
        this.props.callbackFromParent07_text('Slight');
        this.props.callbackFromParent07_complete(1);}
    if (value === 2){
        this.props.callbackFromParent07_text('Moderate');
        this.props.callbackFromParent07_complete(1);}
    if (value === 1){
        this.props.callbackFromParent07_text('Extreme');
        this.props.callbackFromParent07_complete(1);}
    if (value === 0){
        this.props.callbackFromParent07_text('Unable to do');
        this.props.callbackFromParent07_complete(1);}
    if (value === .001){
        this.props.callbackFromParent07_text('N/A');
        this.props.callbackFromParent07_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>7. Ability to perform activity with your normal technique.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>7. Ability to perform activity with your normal technique.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


class Buttons08 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent08(value);        
    if (value === 4){
        this.props.callbackFromParent08_text('None at all');
        this.props.callbackFromParent08_complete(1);}
    if (value === 3){
        this.props.callbackFromParent08_text('Slight');
        this.props.callbackFromParent08_complete(1);}
    if (value === 2){
        this.props.callbackFromParent08_text('Moderate');
        this.props.callbackFromParent08_complete(1);}
    if (value === 1){
        this.props.callbackFromParent08_text('Extreme');
        this.props.callbackFromParent08_complete(1);}
    if (value === 0){
        this.props.callbackFromParent08_text('Unable to do');
        this.props.callbackFromParent08_complete(1);}
    if (value === .001){
        this.props.callbackFromParent08_text('N/A');
        this.props.callbackFromParent08_complete(0);}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>8. Ability to participate in your desired sport as long as you would like.</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>8. Ability to participate in your desired sport as long as you would like.</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None at all</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slight</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable to do</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={.001}> {(this.state.clicked === .001) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} N/A</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
}


    const marks6 = {
      0: <strong>0<p>Inability to perform sports activities</p></strong>,
      10: 10,
      20: 20,
      30: 30,
      40: 40,
      50: <strong>50</strong>,
      60: 60,
      70: 70,
      80: 80,
      90: 90,
      100: <strong>100<p>No change in function</p></strong>,
    };

class Slider09 extends PureComponent {

    constructor(){
         super();
         this.state= {position: 100}
    }

    someFn (value) {
    this.props.callbackFromParent09(value);
    this.props.callbackFromParent09_text(String(value) + '%');    
    this.setState({position: value});
    }

  render() {
    return (
    <div>
    <h4>9. How would you rate your current level of function during your usual sports related activities from 0 to 100 with 100 being your level of function prior to your foot and ankle problem and 0 being the inability to perform any of your usual sports activities.</h4>
        <div style={wrapperStyle2}>
           <Slider dots = {false} min = {0} max = {100} marks={marks6} defaultValue = {100} onChange = {(value) => this.someFn(value)} trackStyle={{ backgroundColor: '#5f8dd3'}}
        handleStyle={{
          borderColor: '#5f8dd3'
        }} dotStyle = {{borderColor: '#5f8dd3'}} />
        </div>
    </div>
  );
  }
}

class Buttons010 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 4}
    }

    someFn (value) {
    this.props.callbackFromParent010(value);        
    if (value === 4){
        this.props.callbackFromParent010_text('Normal');}
    if (value === 3){
        this.props.callbackFromParent010_text('Nearly normal');}
    if (value === 2){
        this.props.callbackFromParent010_text('Abnormal');}
    if (value === 1){
        this.props.callbackFromParent010_text('Severely Abnormal');}        
    this.setState({clicked: value});
    }
              
 

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>How would you rate your current level of function?</h4>
    <ToggleButtonGroup justified type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Normal</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Nearly normal</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Abnormal</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severely abnormal</ToggleButton>
    </ToggleButtonGroup>
    </div>        
    <div class="visible-xs">
    <h4>How would you rate your current level of function?</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" onChange = {(value) => this.someFn(value)} defaultValue={4}>
      <ToggleButton bsStyle="btn-custom" value={4}> {(this.state.clicked === 4) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Normal</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={3}> {(this.state.clicked === 3) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Nearly normal</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={2}> {(this.state.clicked === 2) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Abnormal</ToggleButton>
      <ToggleButton bsStyle="btn-custom" value={1}> {(this.state.clicked === 1) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severely abnormal</ToggleButton>
    </ToggleButtonGroup>
    </div>
    </div>
  );
  }
} 
    
  


class FAAM_Link extends PureComponent {
    
  constructor() {
    super();      
    this.state = {
      currentItem: '', //this is a relic of the tutorial
      username: '', //this is a relic of the tutorial
      user_id: '', //this is the name of the patinet submitting the survey
      clinician_to_share_with: '', //the email that users enter in order to share their score with a clinician
      scores: [], //this displays the scores saved for each clinician
      items: [], //this is a relic of the tutorial   
      user: null, //this is the email address or lack of email address for the clincian who is logged in 
      patient_filter: '', //this allows clinicians to sort for results from a single individual        
      patient_email_to_send_score: '', //this is the variable where clinicians enter the email of a patient they want to send a score to

        
        
        
        
    //Calculator variables    
        
        selectedValue1: 4,
        selectedValue1_complete: 1,
        selectedValue1_text: 'None at all',
        selectedValue2: 4,
        selectedValue2_complete: 1,    
        selectedValue2_text: 'None at all',
        selectedValue3: 4,
        selectedValue3_complete: 1,        
        selectedValue3_text: 'None at all',
        selectedValue4: 4,
        selectedValue4_complete: 1,        
        selectedValue4_text: 'None at all',
        selectedValue5: 4,
        selectedValue5_complete: 1,        
        selectedValue5_text: 'None at all',
        selectedValue6: 4,
        selectedValue6_complete: 1,        
        selectedValue6_text: 'None at all',
        selectedValue7: 4,
        selectedValue7_complete: 1,        
        selectedValue7_text:'None at all',
        selectedValue8: 4,
        selectedValue8_complete: 1,        
        selectedValue8_text:'None at all',
        selectedValue9: 4,
        selectedValue9_complete: 1,        
        selectedValue9_text:'None at all',
        selectedValue10: 4,
        selectedValue10_complete: 1,        
        selectedValue10_text:'None at all',
        selectedValue11: 4,
        selectedValue11_complete: 1,        
        selectedValue11_text:'None at all',
        selectedValue12: 4,
        selectedValue12_complete: 1,        
        selectedValue12_text:'None at all',
        selectedValue13: 4,
        selectedValue13_complete: 1,        
        selectedValue13_text:'None at all',
        selectedValue14: 4,
        selectedValue14_complete: 1,        
        selectedValue14_text:'None at all',
        selectedValue15: 4,
        selectedValue15_complete: 1,        
        selectedValue15_text:'None at all',
        selectedValue16: 4,
        selectedValue16_complete: 1,        
        selectedValue16_text:'None at all',
        selectedValue17: 4,
        selectedValue17_complete: 1,        
        selectedValue17_text:'None at all',
        selectedValue18: 4,
        selectedValue18_complete: 1,        
        selectedValue18_text:'None at all',
        selectedValue19: 4,
        selectedValue19_complete: 1,        
        selectedValue19_text:'None at all',
        selectedValue20: 4,
        selectedValue20_complete: 1,        
        selectedValue20_text:'None at all',
        selectedValue21: 4,
        selectedValue21_complete: 1,        
        selectedValue21_text:'None at all',
        selectedValue22: 100,        
        selectedValue22_text:'100%',
        
        selectedValue01: 4,
        selectedValue01_complete: 1,
        selectedValue01_text: 'None at all',
        selectedValue02: 4,
        selectedValue02_complete: 1,    
        selectedValue02_text: 'None at all',
        selectedValue03: 4,
        selectedValue03_complete: 1,        
        selectedValue03_text: 'None at all',
        selectedValue04: 4,
        selectedValue04_complete: 1,        
        selectedValue04_text: 'None at all',
        selectedValue05: 4,
        selectedValue05_complete: 1,        
        selectedValue05_text: 'None at all',
        selectedValue06: 4,
        selectedValue06_complete: 1,        
        selectedValue06_text: 'None at all', 
        selectedValue07: 4,
        selectedValue07_complete: 1,        
        selectedValue07_text: 'None at all',         
        selectedValue08: 4,
        selectedValue08_complete: 1,        
        selectedValue08_text:'None at all',
        selectedValue09: 100,        
        selectedValue09_text:'100%',
        selectedValue010: 4,        
        selectedValue010_text:'Normal', 
        
        
    }
  this.handleChange = this.handleChange.bind(this);
  this.handleSubmit = this.handleSubmit.bind(this);
  this.handleSubmitSendInvite = this.handleSubmitSendInvite.bind(this);      
  this.login = this.login.bind(this); 
  this.logout = this.logout.bind(this);
     
     
      
  }
    
      

    
componentDidMount() {



    
if (this.state.user != null){
    if(this.state.user.email === "orthotoolkit@gmail.com" | this.state.user.email === "neurologytoolkit@gmail.com"){    
          

  const FAAMScoresRef = firebase.firestore();
  FAAMScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  FAAMScoresRef.collection("faam_scores").get().then(querySnapshot =>{
      
      
      const data = querySnapshot.docs.map(doc => doc.data());
      
    this.setState({
      scores: data
    });  
      
  })
              
        
}  else {
    
  const FAAMScoresRef = firebase.firestore();
  FAAMScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  FAAMScoresRef.collection("faam_scores").where("shared_with", "==", this.state.user.email).get().then(querySnapshot =>{
      
      
      const data = querySnapshot.docs.map(doc => doc.data());
      
    this.setState({
      scores: data
    });  
      
  }) 
      
    
}
}
    

    
    
  auth.onAuthStateChanged((user) => {
    if (user) {
      this.setState({ user });
    }
      

if (this.state.user != null){
    if(this.state.user.email === "orthotoolkit@gmail.com" | this.state.user.email === "neurologytoolkit@gmail.com"){ 
        
  const FAAMScoresRef = firebase.firestore();
  FAAMScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  FAAMScoresRef.collection("faam_scores").get().then(querySnapshot =>{
      
      
      const data = querySnapshot.docs.map(doc => doc.data());
      
    this.setState({
      scores: data
    });  
      
  }) 
                       
        
} else {
    

    
  const FAAMScoresRef = firebase.firestore();
  FAAMScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  FAAMScoresRef.collection("faam_scores").where("shared_with", "==", this.state.user.email).get().then(querySnapshot =>{
      
      
      const data = querySnapshot.docs.map(doc => doc.data());
      
    this.setState({
      scores: data
    });  
      
  }) 
     
    
}
}      

    
      
  });    
    
}    
    
handleChange(e) {
  this.setState({
    [e.target.name]: e.target.value
  });
} 
    
handleSubmit(e) {
  e.preventDefault();  
  const FAAMScoresRef = firebase.firestore();
  FAAMScoresRef.settings({
      timestampsInSnapshots: true
  }); 
    
if (this.props.requestSurveyID.slice(0,4) !== 'zzzz'){    
  const faam_score = FAAMScoresRef.collection("faam_scores").doc(this.props.requestSurveyID).set({            
    shared_with: this.props.clinicianSendingEmail,
    user: this.props.submitterName,
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    score_name: 'Foot and Ankle Ability Measure',
    Question_01_FAAM: this.state.selectedValue1,
    Question_02_FAAM: this.state.selectedValue2,
    Question_03_FAAM: this.state.selectedValue3,
    Question_04_FAAM: this.state.selectedValue4,
    Question_05_FAAM: this.state.selectedValue5,
    Question_06_FAAM: this.state.selectedValue6,
    Question_07_FAAM: this.state.selectedValue7,            
    Question_08_FAAM: this.state.selectedValue8,
    Question_09_FAAM: this.state.selectedValue9,
    Question_10_FAAM: this.state.selectedValue10,
    Question_11_FAAM: this.state.selectedValue11,
    Question_12_FAAM: this.state.selectedValue12,
    Question_13_FAAM: this.state.selectedValue13,
    Question_14_FAAM: this.state.selectedValue14,
    Question_15_FAAM: this.state.selectedValue15,
    Question_16_FAAM: this.state.selectedValue16,
    Question_17_FAAM: this.state.selectedValue17,
    Question_18_FAAM: this.state.selectedValue18,
    Question_19_FAAM: this.state.selectedValue19,
    Question_20_FAAM: this.state.selectedValue20,
    Question_21_FAAM: this.state.selectedValue21,
    Question_22_FAAM: this.state.selectedValue22,
    Question_23_FAAM: this.state.selectedValue01,
    Question_24_FAAM: this.state.selectedValue02,
    Question_25_FAAM: this.state.selectedValue03,
    Question_26_FAAM: this.state.selectedValue04,
    Question_27_FAAM: this.state.selectedValue05,
    Question_28_FAAM: this.state.selectedValue06,
    Question_29_FAAM: this.state.selectedValue07,
    Question_30_FAAM: this.state.selectedValue08,
    Question_31_FAAM: this.state.selectedValue09,
    Question_32_FAAM: this.state.selectedValue010,

      
    ADL_FAAM: Math.round(100*((Number(this.state.selectedValue1_complete)*Number(this.state.selectedValue1) + Number(this.state.selectedValue2_complete)*Number(this.state.selectedValue2) + Number(this.state.selectedValue3_complete)*Number(this.state.selectedValue3) + Number(this.state.selectedValue4_complete)*Number(this.state.selectedValue4) + Number(this.state.selectedValue5_complete)*Number(this.state.selectedValue5) + Number(this.state.selectedValue6_complete)*Number(this.state.selectedValue6) + Number(this.state.selectedValue7_complete)*Number(this.state.selectedValue7) + Number(this.state.selectedValue8_complete)*Number(this.state.selectedValue8) + Number(this.state.selectedValue9_complete)*Number(this.state.selectedValue9) + Number(this.state.selectedValue10_complete)*Number(this.state.selectedValue10) + Number(this.state.selectedValue11_complete)*Number(this.state.selectedValue11) + Number(this.state.selectedValue12_complete)*Number(this.state.selectedValue12) + Number(this.state.selectedValue13_complete)*Number(this.state.selectedValue13) + Number(this.state.selectedValue14_complete)*Number(this.state.selectedValue14) + Number(this.state.selectedValue15_complete)*Number(this.state.selectedValue15) + Number(this.state.selectedValue16_complete)*Number(this.state.selectedValue16) + Number(this.state.selectedValue17_complete)*Number(this.state.selectedValue17) + Number(this.state.selectedValue18_complete)*Number(this.state.selectedValue18) + Number(this.state.selectedValue19_complete)*Number(this.state.selectedValue19) + Number(this.state.selectedValue20_complete)*Number(this.state.selectedValue20) + Number(this.state.selectedValue21_complete)*Number(this.state.selectedValue21))/(4*Number(this.state.selectedValue1_complete) + 4*Number(this.state.selectedValue2_complete) + 4*Number(this.state.selectedValue3_complete) + 4*Number(this.state.selectedValue4_complete) + 4*Number(this.state.selectedValue5_complete) + 4*Number(this.state.selectedValue6_complete) + 4*Number(this.state.selectedValue7_complete) + 4*Number(this.state.selectedValue8_complete) + 4*Number(this.state.selectedValue9_complete) + 4*Number(this.state.selectedValue10_complete) + 4*Number(this.state.selectedValue11_complete) + 4*Number(this.state.selectedValue12_complete) + 4*Number(this.state.selectedValue13_complete) + 4*Number(this.state.selectedValue14_complete) + 4*Number(this.state.selectedValue15_complete) + 4*Number(this.state.selectedValue16_complete) + 4*Number(this.state.selectedValue17_complete) + 4*Number(this.state.selectedValue18_complete) + 4*Number(this.state.selectedValue19_complete) + 4*Number(this.state.selectedValue20_complete) + 4*Number(this.state.selectedValue21_complete)))), 
            
    Sports_FAAM: Math.round(100*((Number(this.state.selectedValue01_complete)*Number(this.state.selectedValue01) + Number(this.state.selectedValue02_complete)*Number(this.state.selectedValue02) + Number(this.state.selectedValue03_complete)*Number(this.state.selectedValue03) + Number(this.state.selectedValue04_complete)*Number(this.state.selectedValue04) + Number(this.state.selectedValue05_complete)*Number(this.state.selectedValue05) + Number(this.state.selectedValue06_complete)*Number(this.state.selectedValue06) + Number(this.state.selectedValue07_complete)*Number(this.state.selectedValue07) + Number(this.state.selectedValue08_complete)*Number(this.state.selectedValue08))/(4*Number(this.state.selectedValue01_complete) + 4*Number(this.state.selectedValue02_complete) + 4*Number(this.state.selectedValue03_complete) + 4*Number(this.state.selectedValue04_complete) + 4*Number(this.state.selectedValue05_complete) + 4*Number(this.state.selectedValue06_complete) + 4*Number(this.state.selectedValue07_complete)+ 4*Number(this.state.selectedValue08_complete)))),      
  });
}
else {
  const faam_score = FAAMScoresRef.collection("faam_scores").add({      
    shared_with: this.props.clinicianSendingEmail,
    user: this.props.submitterName,
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    text_timestamp: this.props.requestSurveyID.substring(4),      
    score_name: 'Foot and Ankle Ability Measure',
    Question_01_FAAM: this.state.selectedValue1,
    Question_02_FAAM: this.state.selectedValue2,
    Question_03_FAAM: this.state.selectedValue3,
    Question_04_FAAM: this.state.selectedValue4,
    Question_05_FAAM: this.state.selectedValue5,
    Question_06_FAAM: this.state.selectedValue6,
    Question_07_FAAM: this.state.selectedValue7,            
    Question_08_FAAM: this.state.selectedValue8,
    Question_09_FAAM: this.state.selectedValue9,
    Question_10_FAAM: this.state.selectedValue10,
    Question_11_FAAM: this.state.selectedValue11,
    Question_12_FAAM: this.state.selectedValue12,
    Question_13_FAAM: this.state.selectedValue13,
    Question_14_FAAM: this.state.selectedValue14,
    Question_15_FAAM: this.state.selectedValue15,
    Question_16_FAAM: this.state.selectedValue16,
    Question_17_FAAM: this.state.selectedValue17,
    Question_18_FAAM: this.state.selectedValue18,
    Question_19_FAAM: this.state.selectedValue19,
    Question_20_FAAM: this.state.selectedValue20,
    Question_21_FAAM: this.state.selectedValue21,
    Question_22_FAAM: this.state.selectedValue22,
    Question_23_FAAM: this.state.selectedValue01,
    Question_24_FAAM: this.state.selectedValue02,
    Question_25_FAAM: this.state.selectedValue03,
    Question_26_FAAM: this.state.selectedValue04,
    Question_27_FAAM: this.state.selectedValue05,
    Question_28_FAAM: this.state.selectedValue06,
    Question_29_FAAM: this.state.selectedValue07,
    Question_30_FAAM: this.state.selectedValue08,
    Question_31_FAAM: this.state.selectedValue09,
    Question_32_FAAM: this.state.selectedValue010,

      
    ADL_FAAM: Math.round(100*((Number(this.state.selectedValue1_complete)*Number(this.state.selectedValue1) + Number(this.state.selectedValue2_complete)*Number(this.state.selectedValue2) + Number(this.state.selectedValue3_complete)*Number(this.state.selectedValue3) + Number(this.state.selectedValue4_complete)*Number(this.state.selectedValue4) + Number(this.state.selectedValue5_complete)*Number(this.state.selectedValue5) + Number(this.state.selectedValue6_complete)*Number(this.state.selectedValue6) + Number(this.state.selectedValue7_complete)*Number(this.state.selectedValue7) + Number(this.state.selectedValue8_complete)*Number(this.state.selectedValue8) + Number(this.state.selectedValue9_complete)*Number(this.state.selectedValue9) + Number(this.state.selectedValue10_complete)*Number(this.state.selectedValue10) + Number(this.state.selectedValue11_complete)*Number(this.state.selectedValue11) + Number(this.state.selectedValue12_complete)*Number(this.state.selectedValue12) + Number(this.state.selectedValue13_complete)*Number(this.state.selectedValue13) + Number(this.state.selectedValue14_complete)*Number(this.state.selectedValue14) + Number(this.state.selectedValue15_complete)*Number(this.state.selectedValue15) + Number(this.state.selectedValue16_complete)*Number(this.state.selectedValue16) + Number(this.state.selectedValue17_complete)*Number(this.state.selectedValue17) + Number(this.state.selectedValue18_complete)*Number(this.state.selectedValue18) + Number(this.state.selectedValue19_complete)*Number(this.state.selectedValue19) + Number(this.state.selectedValue20_complete)*Number(this.state.selectedValue20) + Number(this.state.selectedValue21_complete)*Number(this.state.selectedValue21))/(4*Number(this.state.selectedValue1_complete) + 4*Number(this.state.selectedValue2_complete) + 4*Number(this.state.selectedValue3_complete) + 4*Number(this.state.selectedValue4_complete) + 4*Number(this.state.selectedValue5_complete) + 4*Number(this.state.selectedValue6_complete) + 4*Number(this.state.selectedValue7_complete) + 4*Number(this.state.selectedValue8_complete) + 4*Number(this.state.selectedValue9_complete) + 4*Number(this.state.selectedValue10_complete) + 4*Number(this.state.selectedValue11_complete) + 4*Number(this.state.selectedValue12_complete) + 4*Number(this.state.selectedValue13_complete) + 4*Number(this.state.selectedValue14_complete) + 4*Number(this.state.selectedValue15_complete) + 4*Number(this.state.selectedValue16_complete) + 4*Number(this.state.selectedValue17_complete) + 4*Number(this.state.selectedValue18_complete) + 4*Number(this.state.selectedValue19_complete) + 4*Number(this.state.selectedValue20_complete) + 4*Number(this.state.selectedValue21_complete)))), 
            
    Sports_FAAM: Math.round(100*((Number(this.state.selectedValue01_complete)*Number(this.state.selectedValue01) + Number(this.state.selectedValue02_complete)*Number(this.state.selectedValue02) + Number(this.state.selectedValue03_complete)*Number(this.state.selectedValue03) + Number(this.state.selectedValue04_complete)*Number(this.state.selectedValue04) + Number(this.state.selectedValue05_complete)*Number(this.state.selectedValue05) + Number(this.state.selectedValue06_complete)*Number(this.state.selectedValue06) + Number(this.state.selectedValue07_complete)*Number(this.state.selectedValue07) + Number(this.state.selectedValue08_complete)*Number(this.state.selectedValue08))/(4*Number(this.state.selectedValue01_complete) + 4*Number(this.state.selectedValue02_complete) + 4*Number(this.state.selectedValue03_complete) + 4*Number(this.state.selectedValue04_complete) + 4*Number(this.state.selectedValue05_complete) + 4*Number(this.state.selectedValue06_complete) + 4*Number(this.state.selectedValue07_complete)+ 4*Number(this.state.selectedValue08_complete)))),   
  });      
}     
    
  this.setState({
    clinician_to_share_with: '',
    user_id: '',
  });
    alert('Thank you for using OrthoPowerTools! Your submission was received and will be shared with the following provider: ' + this.props.clinicianSendingEmail + '. You may now close this alert and the entire window.');   
    
}  
    
    
     
    
    
handleSubmitSendInvite(e) {
  e.preventDefault();  
  const PatientInvites = firebase.firestore();
  PatientInvites.settings({
      timestampsInSnapshots: true
  });
  const patient_invites = PatientInvites.collection("faam_patient_invites").add({
    patient_email_to_send_score: this.state.patient_email_to_send_score,
    clinician_who_sent: this.state.user.email,  
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),      
  });
  this.setState({
    patient_email_to_send_score: '',    
  });
    alert('Thank you for using OrthoPowerTools! A message has been sent to the entered email address with a link to complete a survey.');    
    
}      
  
    
    
    
  
login() {
  auth.signInWithPopup(provider) 
    .then((result) => {
      const user = result.user;
      this.setState({
        user
      });
    });
    
}
    
logout() {
  auth.signOut()
    .then(() => {
      this.setState({
        user: null
      });
    });
}
    
  //Calculator Methods




    myCallback1 = (dataFromChild) => {
    this.setState({selectedValue1: dataFromChild});
    }
    
    myCallback1_complete = (dataFromChild) => {
    this.setState({selectedValue1_complete: dataFromChild});    
    }
 
    myCallback1_text = (dataFromChild) => {
    this.setState({selectedValue1_text: dataFromChild});
    }
    
    myCallback2 = (dataFromChild) => {
    this.setState({selectedValue2: dataFromChild});
    }
    
    myCallback2_complete = (dataFromChild) => {
    this.setState({selectedValue2_complete: dataFromChild});    
    }    
    
    myCallback2_text = (dataFromChild) => {
    this.setState({selectedValue2_text: dataFromChild});
    }
    
    myCallback3 = (dataFromChild) => {
    this.setState({selectedValue3: dataFromChild});
    }
    
    myCallback3_complete = (dataFromChild) => {
    this.setState({selectedValue3_complete: dataFromChild});    
    }    
    
    myCallback3_text = (dataFromChild) => {
    this.setState({selectedValue3_text: dataFromChild});
    }    
    
    myCallback4 = (dataFromChild) => {
    this.setState({selectedValue4: dataFromChild});
    }
    
    myCallback4_complete = (dataFromChild) => {
    this.setState({selectedValue4_complete: dataFromChild});    
    }    
    
    myCallback4_text = (dataFromChild) => {
    this.setState({selectedValue4_text: dataFromChild});
    }  
    
    myCallback5 = (dataFromChild) => {
    this.setState({selectedValue5: dataFromChild});
    }
    
    myCallback5_complete = (dataFromChild) => {
    this.setState({selectedValue5_complete: dataFromChild});    
    }    
    
    myCallback5_text = (dataFromChild) => {
    this.setState({selectedValue5_text: dataFromChild});
    }    
    
    myCallback6 = (dataFromChild) => {
    this.setState({selectedValue6: dataFromChild});
    }
    
    myCallback6_complete = (dataFromChild) => {
    this.setState({selectedValue6_complete: dataFromChild});    
    }    
    
    myCallback6_text = (dataFromChild) => {
    this.setState({selectedValue6_text: dataFromChild});
    }      
    
    myCallback7 = (dataFromChild) => {
    this.setState({selectedValue7: dataFromChild});
    }
    
    myCallback7_complete = (dataFromChild) => {
    this.setState({selectedValue7_complete: dataFromChild});    
    }    
    
    myCallback7_text = (dataFromChild) => {
    this.setState({selectedValue7_text: dataFromChild});
    }    
    
    myCallback8 = (dataFromChild) => {
    this.setState({selectedValue8: dataFromChild});
    }
    
    myCallback8_complete = (dataFromChild) => {
    this.setState({selectedValue8_complete: dataFromChild});    
    }    
    
    myCallback8_text = (dataFromChild) => {
    this.setState({selectedValue8_text: dataFromChild});
    }      
    
    myCallback9 = (dataFromChild) => {
    this.setState({selectedValue9: dataFromChild});
    }
    
    myCallback9_complete = (dataFromChild) => {
    this.setState({selectedValue9_complete: dataFromChild});    
    }    
    
    myCallback9_text = (dataFromChild) => {
    this.setState({selectedValue9_text: dataFromChild});
    }    
    
    myCallback10 = (dataFromChild) => {
    this.setState({selectedValue10: dataFromChild});
    }
    
    myCallback10_complete = (dataFromChild) => {
    this.setState({selectedValue10_complete: dataFromChild});    
    }    
    
    myCallback10_text = (dataFromChild) => {
    this.setState({selectedValue10_text: dataFromChild});
    }
    
    myCallback11 = (dataFromChild) => {
    this.setState({selectedValue11: dataFromChild});
    }
    
    myCallback11_complete = (dataFromChild) => {
    this.setState({selectedValue11_complete: dataFromChild});    
    }    
    
    myCallback11_text = (dataFromChild) => {
    this.setState({selectedValue11_text: dataFromChild});
    } 
    
    myCallback12 = (dataFromChild) => {
    this.setState({selectedValue12: dataFromChild});
    }
    
    myCallback12_complete = (dataFromChild) => {
    this.setState({selectedValue12_complete: dataFromChild});    
    }    
    
    myCallback12_text = (dataFromChild) => {
    this.setState({selectedValue12_text: dataFromChild});
    } 
    
    myCallback13 = (dataFromChild) => {
    this.setState({selectedValue13: dataFromChild});
    }
    
    myCallback13_complete = (dataFromChild) => {
    this.setState({selectedValue13_complete: dataFromChild});    
    }    
    
    myCallback13_text = (dataFromChild) => {
    this.setState({selectedValue13_text: dataFromChild});
    } 
    
    myCallback14 = (dataFromChild) => {
    this.setState({selectedValue14: dataFromChild});
    }
    
    myCallback14_complete = (dataFromChild) => {
    this.setState({selectedValue14_complete: dataFromChild});    
    }    
    
    myCallback14_text = (dataFromChild) => {
    this.setState({selectedValue14_text: dataFromChild});
    } 
    
    myCallback15 = (dataFromChild) => {
    this.setState({selectedValue15: dataFromChild});
    }
    
    myCallback15_complete = (dataFromChild) => {
    this.setState({selectedValue15_complete: dataFromChild});    
    }    
    
    myCallback15_text = (dataFromChild) => {
    this.setState({selectedValue15_text: dataFromChild});
    } 
    
    myCallback16 = (dataFromChild) => {
    this.setState({selectedValue16: dataFromChild});
    }
    
    myCallback16_complete = (dataFromChild) => {
    this.setState({selectedValue16_complete: dataFromChild});    
    }    
    
    myCallback16_text = (dataFromChild) => {
    this.setState({selectedValue16_text: dataFromChild});
    } 
    
    myCallback17 = (dataFromChild) => {
    this.setState({selectedValue17: dataFromChild});
    }
    
    myCallback17_complete = (dataFromChild) => {
    this.setState({selectedValue17_complete: dataFromChild});    
    }    
    
    myCallback17_text = (dataFromChild) => {
    this.setState({selectedValue17_text: dataFromChild});
    } 
    
    myCallback18 = (dataFromChild) => {
    this.setState({selectedValue18: dataFromChild});
    }
    
    myCallback18_complete = (dataFromChild) => {
    this.setState({selectedValue18_complete: dataFromChild});    
    }    
    
    myCallback18_text = (dataFromChild) => {
    this.setState({selectedValue18_text: dataFromChild});
    } 
    
    myCallback19 = (dataFromChild) => {
    this.setState({selectedValue19: dataFromChild});
    }
    
    myCallback19_complete = (dataFromChild) => {
    this.setState({selectedValue19_complete: dataFromChild});    
    }    
    
    myCallback19_text = (dataFromChild) => {
    this.setState({selectedValue19_text: dataFromChild});
    } 
    
    myCallback20 = (dataFromChild) => {
    this.setState({selectedValue20: dataFromChild});
    }
    
    myCallback20_complete = (dataFromChild) => {
    this.setState({selectedValue20_complete: dataFromChild});    
    }    
    
    myCallback20_text = (dataFromChild) => {
    this.setState({selectedValue20_text: dataFromChild});
    } 
    
    myCallback21 = (dataFromChild) => {
    this.setState({selectedValue21: dataFromChild});
    }
    
    myCallback21_complete = (dataFromChild) => {
    this.setState({selectedValue21_complete: dataFromChild});    
    }    
    
    myCallback21_text = (dataFromChild) => {
    this.setState({selectedValue21_text: dataFromChild});
    } 
    
    myCallback22 = (dataFromChild) => {
    this.setState({selectedValue22: dataFromChild});
    }    
    
    myCallback22_text = (dataFromChild) => {
    this.setState({selectedValue22_text: dataFromChild});
    }     
    
    
    
    
    myCallback01 = (dataFromChild) => {
    this.setState({selectedValue01: dataFromChild});
    }
    
    myCallback01_complete = (dataFromChild) => {
    this.setState({selectedValue01_complete: dataFromChild});    
    }
 
    myCallback01_text = (dataFromChild) => {
    this.setState({selectedValue01_text: dataFromChild});
    }
    
    myCallback02 = (dataFromChild) => {
    this.setState({selectedValue02: dataFromChild});
    }
    
    myCallback02_complete = (dataFromChild) => {
    this.setState({selectedValue02_complete: dataFromChild});    
    }    
    
    myCallback02_text = (dataFromChild) => {
    this.setState({selectedValue02_text: dataFromChild});
    }
    
    myCallback03 = (dataFromChild) => {
    this.setState({selectedValue03: dataFromChild});
    }
    
    myCallback03_complete = (dataFromChild) => {
    this.setState({selectedValue03_complete: dataFromChild});    
    }    
    
    myCallback03_text = (dataFromChild) => {
    this.setState({selectedValue03_text: dataFromChild});
    }    
    
    myCallback04 = (dataFromChild) => {
    this.setState({selectedValue04: dataFromChild});
    }
    
    myCallback04_complete = (dataFromChild) => {
    this.setState({selectedValue04_complete: dataFromChild});    
    }    
    
    myCallback04_text = (dataFromChild) => {
    this.setState({selectedValue04_text: dataFromChild});
    }  
    
    myCallback05 = (dataFromChild) => {
    this.setState({selectedValue05: dataFromChild});
    }
    
    myCallback05_complete = (dataFromChild) => {
    this.setState({selectedValue05_complete: dataFromChild});    
    }    
    
    myCallback05_text = (dataFromChild) => {
    this.setState({selectedValue05_text: dataFromChild});
    }    
    
    myCallback06 = (dataFromChild) => {
    this.setState({selectedValue06: dataFromChild});
    }
    
    myCallback06_complete = (dataFromChild) => {
    this.setState({selectedValue06_complete: dataFromChild});    
    }    
    
    myCallback06_text = (dataFromChild) => {
    this.setState({selectedValue06_text: dataFromChild});
    }      
    
    myCallback07 = (dataFromChild) => {
    this.setState({selectedValue07: dataFromChild});
    }
    
    myCallback07_complete = (dataFromChild) => {
    this.setState({selectedValue07_complete: dataFromChild});    
    }    
    
    myCallback07_text = (dataFromChild) => {
    this.setState({selectedValue07_text: dataFromChild});
    } 
    
    myCallback08 = (dataFromChild) => {
    this.setState({selectedValue08: dataFromChild});
    }
    
    myCallback08_complete = (dataFromChild) => {
    this.setState({selectedValue08_complete: dataFromChild});    
    }    
    
    myCallback08_text = (dataFromChild) => {
    this.setState({selectedValue08_text: dataFromChild});
    }     
    
    myCallback09 = (dataFromChild) => {
    this.setState({selectedValue09: dataFromChild});
    }  
    
    myCallback09_text = (dataFromChild) => {
    this.setState({selectedValue09_text: dataFromChild});
    }
    
    myCallback010 = (dataFromChild) => {
    this.setState({selectedValue010: dataFromChild});
    }  
    
    myCallback010_text = (dataFromChild) => {
    this.setState({selectedValue010_text: dataFromChild});
    }      
    
  
    
    

    
render() { 

  return (
     
    <div className='app'>
      <header>
        <div className="wrapper">
        <Link to="/"><img src={mainLogo} style={{padding:15,width:200}} alt="orthotoolkit logo"/></Link>      
        </div>
      </header>            
            
            
            <div className="App">
                <h1>Foot and Ankle Ability Measure (FAAM) Calculator</h1>
                <h4>Hello, {this.props.submitterName}, your clinician, {this.props.clinicianSendingEmail}, has sent you this survey to help further understand your health. Please click the appropriate buttons below and then click "Submit Score". Please note that your <u>digital privacy is taken very seriously</u> and a number of technologies have been implemented to protect the privacy and integrity of your data, including the use of SSL encryption, HIPAA compliant storage, and state-of-the-art authentication services. Your data <u>will never be shared with anyone other than the assigned clinician</u>.</h4>

            <form onSubmit={this.handleSubmit}>



        <StickyContainer>
          <Sticky>
            {({ style }) => <div className="sticky_style" style={style}><Well bsSize="small">FAAM Activities of Daily Living Subscale: {Number(this.state.selectedValue1_complete)*Number(this.state.selectedValue1) + Number(this.state.selectedValue2_complete)*Number(this.state.selectedValue2) + Number(this.state.selectedValue3_complete)*Number(this.state.selectedValue3) + Number(this.state.selectedValue4_complete)*Number(this.state.selectedValue4) + Number(this.state.selectedValue5_complete)*Number(this.state.selectedValue5) + Number(this.state.selectedValue6_complete)*Number(this.state.selectedValue6) + Number(this.state.selectedValue7_complete)*Number(this.state.selectedValue7) + Number(this.state.selectedValue8_complete)*Number(this.state.selectedValue8) + Number(this.state.selectedValue9_complete)*Number(this.state.selectedValue9) + Number(this.state.selectedValue10_complete)*Number(this.state.selectedValue10) + Number(this.state.selectedValue11_complete)*Number(this.state.selectedValue11) + Number(this.state.selectedValue12_complete)*Number(this.state.selectedValue12) + Number(this.state.selectedValue13_complete)*Number(this.state.selectedValue13) + Number(this.state.selectedValue14_complete)*Number(this.state.selectedValue14) + Number(this.state.selectedValue15_complete)*Number(this.state.selectedValue15) + Number(this.state.selectedValue16_complete)*Number(this.state.selectedValue16) + Number(this.state.selectedValue17_complete)*Number(this.state.selectedValue17) + Number(this.state.selectedValue18_complete)*Number(this.state.selectedValue18) + Number(this.state.selectedValue19_complete)*Number(this.state.selectedValue19) + Number(this.state.selectedValue20_complete)*Number(this.state.selectedValue20) + Number(this.state.selectedValue21_complete)*Number(this.state.selectedValue21)} / {4*Number(this.state.selectedValue1_complete) + 4*Number(this.state.selectedValue2_complete) + 4*Number(this.state.selectedValue3_complete) + 4*Number(this.state.selectedValue4_complete) + 4*Number(this.state.selectedValue5_complete) + 4*Number(this.state.selectedValue6_complete) + 4*Number(this.state.selectedValue7_complete) + 4*Number(this.state.selectedValue8_complete) + 4*Number(this.state.selectedValue9_complete) + 4*Number(this.state.selectedValue10_complete) + 4*Number(this.state.selectedValue11_complete) + 4*Number(this.state.selectedValue12_complete) + 4*Number(this.state.selectedValue13_complete) + 4*Number(this.state.selectedValue14_complete) + 4*Number(this.state.selectedValue15_complete) + 4*Number(this.state.selectedValue16_complete) + 4*Number(this.state.selectedValue17_complete) + 4*Number(this.state.selectedValue18_complete) + 4*Number(this.state.selectedValue19_complete) + 4*Number(this.state.selectedValue20_complete) + 4*Number(this.state.selectedValue21_complete)} or {Math.round(100*((Number(this.state.selectedValue1_complete)*Number(this.state.selectedValue1) + Number(this.state.selectedValue2_complete)*Number(this.state.selectedValue2) + Number(this.state.selectedValue3_complete)*Number(this.state.selectedValue3) + Number(this.state.selectedValue4_complete)*Number(this.state.selectedValue4) + Number(this.state.selectedValue5_complete)*Number(this.state.selectedValue5) + Number(this.state.selectedValue6_complete)*Number(this.state.selectedValue6) + Number(this.state.selectedValue7_complete)*Number(this.state.selectedValue7) + Number(this.state.selectedValue8_complete)*Number(this.state.selectedValue8) + Number(this.state.selectedValue9_complete)*Number(this.state.selectedValue9) + Number(this.state.selectedValue10_complete)*Number(this.state.selectedValue10) + Number(this.state.selectedValue11_complete)*Number(this.state.selectedValue11) + Number(this.state.selectedValue12_complete)*Number(this.state.selectedValue12) + Number(this.state.selectedValue13_complete)*Number(this.state.selectedValue13) + Number(this.state.selectedValue14_complete)*Number(this.state.selectedValue14) + Number(this.state.selectedValue15_complete)*Number(this.state.selectedValue15) + Number(this.state.selectedValue16_complete)*Number(this.state.selectedValue16) + Number(this.state.selectedValue17_complete)*Number(this.state.selectedValue17) + Number(this.state.selectedValue18_complete)*Number(this.state.selectedValue18) + Number(this.state.selectedValue19_complete)*Number(this.state.selectedValue19) + Number(this.state.selectedValue20_complete)*Number(this.state.selectedValue20) + Number(this.state.selectedValue21_complete)*Number(this.state.selectedValue21))/(4*Number(this.state.selectedValue1_complete) + 4*Number(this.state.selectedValue2_complete) + 4*Number(this.state.selectedValue3_complete) + 4*Number(this.state.selectedValue4_complete) + 4*Number(this.state.selectedValue5_complete) + 4*Number(this.state.selectedValue6_complete) + 4*Number(this.state.selectedValue7_complete) + 4*Number(this.state.selectedValue8_complete) + 4*Number(this.state.selectedValue9_complete) + 4*Number(this.state.selectedValue10_complete) + 4*Number(this.state.selectedValue11_complete) + 4*Number(this.state.selectedValue12_complete) + 4*Number(this.state.selectedValue13_complete) + 4*Number(this.state.selectedValue14_complete) + 4*Number(this.state.selectedValue15_complete) + 4*Number(this.state.selectedValue16_complete) + 4*Number(this.state.selectedValue17_complete) + 4*Number(this.state.selectedValue18_complete) + 4*Number(this.state.selectedValue19_complete) + 4*Number(this.state.selectedValue20_complete) + 4*Number(this.state.selectedValue21_complete))))} %
            <p/>

            Graphical FAAM Activities of Daily Living Subscale: (%)
            <ProgressBar>
            <ProgressBar active now={(100*((Number(this.state.selectedValue1_complete)*Number(this.state.selectedValue1) + Number(this.state.selectedValue2_complete)*Number(this.state.selectedValue2) + Number(this.state.selectedValue3_complete)*Number(this.state.selectedValue3) + Number(this.state.selectedValue4_complete)*Number(this.state.selectedValue4) + Number(this.state.selectedValue5_complete)*Number(this.state.selectedValue5) + Number(this.state.selectedValue6_complete)*Number(this.state.selectedValue6) + Number(this.state.selectedValue7_complete)*Number(this.state.selectedValue7) + Number(this.state.selectedValue8_complete)*Number(this.state.selectedValue8) + Number(this.state.selectedValue9_complete)*Number(this.state.selectedValue9) + Number(this.state.selectedValue10_complete)*Number(this.state.selectedValue10) + Number(this.state.selectedValue11_complete)*Number(this.state.selectedValue11) + Number(this.state.selectedValue12_complete)*Number(this.state.selectedValue12) + Number(this.state.selectedValue13_complete)*Number(this.state.selectedValue13) + Number(this.state.selectedValue14_complete)*Number(this.state.selectedValue14) + Number(this.state.selectedValue15_complete)*Number(this.state.selectedValue15) + Number(this.state.selectedValue16_complete)*Number(this.state.selectedValue16) + Number(this.state.selectedValue17_complete)*Number(this.state.selectedValue17) + Number(this.state.selectedValue18_complete)*Number(this.state.selectedValue18) + Number(this.state.selectedValue19_complete)*Number(this.state.selectedValue19) + Number(this.state.selectedValue20_complete)*Number(this.state.selectedValue20) + Number(this.state.selectedValue21_complete)*Number(this.state.selectedValue21))/(4*Number(this.state.selectedValue1_complete) + 4*Number(this.state.selectedValue2_complete) + 4*Number(this.state.selectedValue3_complete) + 4*Number(this.state.selectedValue4_complete) + 4*Number(this.state.selectedValue5_complete) + 4*Number(this.state.selectedValue6_complete) + 4*Number(this.state.selectedValue7_complete) + 4*Number(this.state.selectedValue8_complete) + 4*Number(this.state.selectedValue9_complete) + 4*Number(this.state.selectedValue10_complete) + 4*Number(this.state.selectedValue11_complete) + 4*Number(this.state.selectedValue12_complete) + 4*Number(this.state.selectedValue13_complete) + 4*Number(this.state.selectedValue14_complete) + 4*Number(this.state.selectedValue15_complete) + 4*Number(this.state.selectedValue16_complete) + 4*Number(this.state.selectedValue17_complete) + 4*Number(this.state.selectedValue18_complete) + 4*Number(this.state.selectedValue19_complete) + 4*Number(this.state.selectedValue20_complete) + 4*Number(this.state.selectedValue21_complete))))}/>
            <ProgressBar active bsStyle="danger" now={100-(100*((Number(this.state.selectedValue1_complete)*Number(this.state.selectedValue1) + Number(this.state.selectedValue2_complete)*Number(this.state.selectedValue2) + Number(this.state.selectedValue3_complete)*Number(this.state.selectedValue3) + Number(this.state.selectedValue4_complete)*Number(this.state.selectedValue4) + Number(this.state.selectedValue5_complete)*Number(this.state.selectedValue5) + Number(this.state.selectedValue6_complete)*Number(this.state.selectedValue6) + Number(this.state.selectedValue7_complete)*Number(this.state.selectedValue7) + Number(this.state.selectedValue8_complete)*Number(this.state.selectedValue8) + Number(this.state.selectedValue9_complete)*Number(this.state.selectedValue9) + Number(this.state.selectedValue10_complete)*Number(this.state.selectedValue10) + Number(this.state.selectedValue11_complete)*Number(this.state.selectedValue11) + Number(this.state.selectedValue12_complete)*Number(this.state.selectedValue12) + Number(this.state.selectedValue13_complete)*Number(this.state.selectedValue13) + Number(this.state.selectedValue14_complete)*Number(this.state.selectedValue14) + Number(this.state.selectedValue15_complete)*Number(this.state.selectedValue15) + Number(this.state.selectedValue16_complete)*Number(this.state.selectedValue16) + Number(this.state.selectedValue17_complete)*Number(this.state.selectedValue17) + Number(this.state.selectedValue18_complete)*Number(this.state.selectedValue18) + Number(this.state.selectedValue19_complete)*Number(this.state.selectedValue19) + Number(this.state.selectedValue20_complete)*Number(this.state.selectedValue20) + Number(this.state.selectedValue21_complete)*Number(this.state.selectedValue21))/(4*Number(this.state.selectedValue1_complete) + 4*Number(this.state.selectedValue2_complete) + 4*Number(this.state.selectedValue3_complete) + 4*Number(this.state.selectedValue4_complete) + 4*Number(this.state.selectedValue5_complete) + 4*Number(this.state.selectedValue6_complete) + 4*Number(this.state.selectedValue7_complete) + 4*Number(this.state.selectedValue8_complete) + 4*Number(this.state.selectedValue9_complete) + 4*Number(this.state.selectedValue10_complete) + 4*Number(this.state.selectedValue11_complete) + 4*Number(this.state.selectedValue12_complete) + 4*Number(this.state.selectedValue13_complete) + 4*Number(this.state.selectedValue14_complete) + 4*Number(this.state.selectedValue15_complete) + 4*Number(this.state.selectedValue16_complete) + 4*Number(this.state.selectedValue17_complete) + 4*Number(this.state.selectedValue18_complete) + 4*Number(this.state.selectedValue19_complete) + 4*Number(this.state.selectedValue20_complete) + 4*Number(this.state.selectedValue21_complete))))}/>
            </ProgressBar>
            </Well>
            </div>}

          </Sticky>  
                <p />
                    
        <br />          
        <Buttons1 callbackFromParent1={this.myCallback1} callbackFromParent1_complete={this.myCallback1_complete} callbackFromParent1_text={this.myCallback1_text}/>
        <Buttons2 callbackFromParent2={this.myCallback2} callbackFromParent2_complete={this.myCallback2_complete} callbackFromParent2_text={this.myCallback2_text}/>
        <Buttons3 callbackFromParent3={this.myCallback3} callbackFromParent3_complete={this.myCallback3_complete} callbackFromParent3_text={this.myCallback3_text}/>
        <Buttons4 callbackFromParent4={this.myCallback4} callbackFromParent4_complete={this.myCallback4_complete} callbackFromParent4_text={this.myCallback4_text}/>
        <Buttons5 callbackFromParent5={this.myCallback5} callbackFromParent5_complete={this.myCallback5_complete} callbackFromParent5_text={this.myCallback5_text}/>
        <Buttons6 callbackFromParent6={this.myCallback6} callbackFromParent6_complete={this.myCallback6_complete} callbackFromParent6_text={this.myCallback6_text}/>
        <Buttons7 callbackFromParent7={this.myCallback7} callbackFromParent7_complete={this.myCallback7_complete} callbackFromParent7_text={this.myCallback7_text}/>
        <Buttons8 callbackFromParent8={this.myCallback8} callbackFromParent8_complete={this.myCallback8_complete} callbackFromParent8_text={this.myCallback8_text}/>
        <Buttons9 callbackFromParent9={this.myCallback9} callbackFromParent9_complete={this.myCallback9_complete} callbackFromParent9_text={this.myCallback9_text}/>
        <Buttons10 callbackFromParent10={this.myCallback10} callbackFromParent10_complete={this.myCallback10_complete} callbackFromParent10_text={this.myCallback10_text}/>
        <Buttons11 callbackFromParent11={this.myCallback11} callbackFromParent11_complete={this.myCallback11_complete} callbackFromParent11_text={this.myCallback11_text}/>
        <Buttons12 callbackFromParent12={this.myCallback12} callbackFromParent12_complete={this.myCallback12_complete} callbackFromParent12_text={this.myCallback12_text}/>
        <Buttons13 callbackFromParent13={this.myCallback13} callbackFromParent13_complete={this.myCallback13_complete} callbackFromParent13_text={this.myCallback13_text}/>
        <Buttons14 callbackFromParent14={this.myCallback14} callbackFromParent14_complete={this.myCallback14_complete} callbackFromParent14_text={this.myCallback14_text}/>
        <Buttons15 callbackFromParent15={this.myCallback15} callbackFromParent15_complete={this.myCallback15_complete} callbackFromParent15_text={this.myCallback15_text}/>
        <Buttons16 callbackFromParent16={this.myCallback16} callbackFromParent16_complete={this.myCallback16_complete} callbackFromParent16_text={this.myCallback16_text}/>
        <Buttons17 callbackFromParent17={this.myCallback17} callbackFromParent17_complete={this.myCallback17_complete} callbackFromParent17_text={this.myCallback17_text}/>
        <Buttons18 callbackFromParent18={this.myCallback18} callbackFromParent18_complete={this.myCallback18_complete} callbackFromParent18_text={this.myCallback18_text}/>
        <Buttons19 callbackFromParent19={this.myCallback19} callbackFromParent19_complete={this.myCallback19_complete} callbackFromParent19_text={this.myCallback19_text}/>
        <Buttons20 callbackFromParent20={this.myCallback20} callbackFromParent20_complete={this.myCallback20_complete} callbackFromParent20_text={this.myCallback20_text}/>
        <Buttons21 callbackFromParent21={this.myCallback21} callbackFromParent21_complete={this.myCallback21_complete} callbackFromParent21_text={this.myCallback21_text}/>
        <Slider22 callbackFromParent22={this.myCallback22} callbackFromParent22_text={this.myCallback22_text}/> 
            
        </StickyContainer>    

        <StickyContainer>
          <Sticky>
            {({ style }) => <div className="sticky_style" style={style}><Well bsSize="small">FAAM Sports Subscale: {Number(this.state.selectedValue01_complete)*Number(this.state.selectedValue01) + Number(this.state.selectedValue02_complete)*Number(this.state.selectedValue02) + Number(this.state.selectedValue03_complete)*Number(this.state.selectedValue03) + Number(this.state.selectedValue04_complete)*Number(this.state.selectedValue04) + Number(this.state.selectedValue05_complete)*Number(this.state.selectedValue05) + Number(this.state.selectedValue06_complete)*Number(this.state.selectedValue06) + Number(this.state.selectedValue07_complete)*Number(this.state.selectedValue07) + Number(this.state.selectedValue08_complete)*Number(this.state.selectedValue08)} / {4*Number(this.state.selectedValue01_complete) + 4*Number(this.state.selectedValue02_complete) + 4*Number(this.state.selectedValue03_complete) + 4*Number(this.state.selectedValue04_complete) + 4*Number(this.state.selectedValue05_complete) + 4*Number(this.state.selectedValue06_complete) + 4*Number(this.state.selectedValue07_complete) + 4*Number(this.state.selectedValue08_complete)} or {Math.round(100*((Number(this.state.selectedValue01_complete)*Number(this.state.selectedValue01) + Number(this.state.selectedValue02_complete)*Number(this.state.selectedValue02) + Number(this.state.selectedValue03_complete)*Number(this.state.selectedValue03) + Number(this.state.selectedValue04_complete)*Number(this.state.selectedValue04) + Number(this.state.selectedValue05_complete)*Number(this.state.selectedValue05) + Number(this.state.selectedValue06_complete)*Number(this.state.selectedValue06) + Number(this.state.selectedValue07_complete)*Number(this.state.selectedValue07) + Number(this.state.selectedValue08_complete)*Number(this.state.selectedValue08))/(4*Number(this.state.selectedValue01_complete) + 4*Number(this.state.selectedValue02_complete) + 4*Number(this.state.selectedValue03_complete) + 4*Number(this.state.selectedValue04_complete) + 4*Number(this.state.selectedValue05_complete) + 4*Number(this.state.selectedValue06_complete) + 4*Number(this.state.selectedValue07_complete) + 4*Number(this.state.selectedValue08_complete))))} %
            <p/>

            Graphical FAAM Sports Subscale: (%)
            <ProgressBar>
                    <ProgressBar active now={(100*((Number(this.state.selectedValue01_complete)*Number(this.state.selectedValue01) + Number(this.state.selectedValue02_complete)*Number(this.state.selectedValue02) + Number(this.state.selectedValue03_complete)*Number(this.state.selectedValue03) + Number(this.state.selectedValue04_complete)*Number(this.state.selectedValue04) + Number(this.state.selectedValue05_complete)*Number(this.state.selectedValue05) + Number(this.state.selectedValue06_complete)*Number(this.state.selectedValue06) + Number(this.state.selectedValue07_complete)*Number(this.state.selectedValue07) + Number(this.state.selectedValue08_complete)*Number(this.state.selectedValue08))/ (4*Number(this.state.selectedValue01_complete) + 4*Number(this.state.selectedValue02_complete) + 4*Number(this.state.selectedValue03_complete) + 4*Number(this.state.selectedValue04_complete) + 4*Number(this.state.selectedValue05_complete) + 4*Number(this.state.selectedValue06_complete) + 4*Number(this.state.selectedValue07_complete)  + 4*Number(this.state.selectedValue08_complete))))}/>
                    <ProgressBar active bsStyle="danger" now={100-(100*((Number(this.state.selectedValue01_complete)*Number(this.state.selectedValue01) + Number(this.state.selectedValue02_complete)*Number(this.state.selectedValue02) + Number(this.state.selectedValue03_complete)*Number(this.state.selectedValue03) + Number(this.state.selectedValue04_complete)*Number(this.state.selectedValue04) + Number(this.state.selectedValue05_complete)*Number(this.state.selectedValue05) + Number(this.state.selectedValue06_complete)*Number(this.state.selectedValue06) + Number(this.state.selectedValue07_complete)*Number(this.state.selectedValue07) + Number(this.state.selectedValue08_complete)*Number(this.state.selectedValue08))/ (4*Number(this.state.selectedValue01_complete) + 4*Number(this.state.selectedValue02_complete) + 4*Number(this.state.selectedValue03_complete) + 4*Number(this.state.selectedValue04_complete) + 4*Number(this.state.selectedValue05_complete) + 4*Number(this.state.selectedValue06_complete) + 4*Number(this.state.selectedValue07_complete)  + 4*Number(this.state.selectedValue08_complete))))}/>
            </ProgressBar>
            </Well>
            </div>}

          </Sticky>      


        <p />
        <br />                        
       
            
        <Buttons01 callbackFromParent01={this.myCallback01} callbackFromParent01_complete={this.myCallback01_complete} callbackFromParent01_text={this.myCallback01_text}/>
        <Buttons02 callbackFromParent02={this.myCallback02} callbackFromParent02_complete={this.myCallback02_complete} callbackFromParent02_text={this.myCallback02_text}/>
        <Buttons03 callbackFromParent03={this.myCallback03} callbackFromParent03_complete={this.myCallback03_complete} callbackFromParent03_text={this.myCallback03_text}/>
        <Buttons04 callbackFromParent04={this.myCallback04} callbackFromParent04_complete={this.myCallback04_complete} callbackFromParent04_text={this.myCallback04_text}/>
        <Buttons05 callbackFromParent05={this.myCallback05} callbackFromParent05_complete={this.myCallback05_complete} callbackFromParent05_text={this.myCallback05_text}/>
        <Buttons06 callbackFromParent06={this.myCallback06} callbackFromParent06_complete={this.myCallback06_complete} callbackFromParent06_text={this.myCallback06_text}/>
        <Buttons07 callbackFromParent07={this.myCallback07} callbackFromParent07_complete={this.myCallback07_complete} callbackFromParent07_text={this.myCallback07_text}/>
        <Buttons08 callbackFromParent08={this.myCallback08} callbackFromParent08_complete={this.myCallback08_complete} callbackFromParent08_text={this.myCallback08_text}/>            
        <Slider09 callbackFromParent09={this.myCallback09} callbackFromParent09_text={this.myCallback09_text}/>  
        <Buttons010 callbackFromParent010={this.myCallback010} callbackFromParent010_text={this.myCallback010_text}/>
        </StickyContainer>
        <p></p>     

                
                
                
                

                <br />
                    
              <button style = {{width: '100%'}}>Submit Score</button>                    
                    
            </form>    

            </div>     

    </div>
            
      
      
  );
}
}
    
export default withRouter(FAAM_Link);
